export default class hearbeatParser {
    static process(clientStater, msg) {
        clientStater.dispatch(msg.guid, { code: 200 });
    }
}
//# sourceMappingURL=hearbeatParser.js.map